import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { ContextualBanner } from '@calendly/ui/components/contextual-banner';
import { FlexLayout } from '@calendly/ui/components/flex-layout';
import { Link } from '@calendly/ui/components/link';
import { Loader } from '@calendly/ui/components/loader';
import { TitleText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { useEffect, forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import { Step } from 'features/organization_settings/shared/step';
import { Description } from '../styles';
import { Connection } from './connection';
import { SAML_STEPS } from './constants';
import { DestroySettings } from './destroy_settings';
import { Enforcement } from './enforcement';
import { IdpInformation } from './idp_information';
import { currentStepSelector, isLoadingSelector, ssoConfiguredSelector, ssoEnforcedSelector, ssoTestedSelector } from './selectors';
import { selectStep } from './slice';
import { TestSamlConnectionButton } from './test_saml_connection_button';
import { fetchAggregateSsoSettings } from './thunks';
const flexBoxCss = "f13jd2b1";
const FlexBox = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(flexBoxCss, props.className)} />;
});
const SsoHelpCenterLink = ({
  children
}) => <Link href="https://help.calendly.com/hc/en-us/articles/360056867653" target="_blank" rel="noreferrer noopener">{children}</Link>;
const UserProvisioningLink = () => <Link underline variant="subtle" as={RouterLink} to="/app/admin/login/user_provisioning">
    {I18n.t('publisher.organization_settings.user_provisioning.header')}
  </Link>;
export const SingleSignOnSetup = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector(isLoadingSelector);
  const selectedStep = useSelector(currentStepSelector);
  const isEnforced = useSelector(ssoEnforcedSelector);
  const isTested = useSelector(ssoTestedSelector);
  const isConfigured = useSelector(ssoConfiguredSelector);
  useEffect(() => {
    dispatch(fetchAggregateSsoSettings());
  }, [dispatch]);
  return <>
      <FlexLayout direction="column" gap={16}>
        <TitleText level={2} size="medium">
          {I18n.t('publisher.organization_settings.sso.header')}
        </TitleText>
        <Description>
          {HtmlParser(I18n.t('publisher.organization_settings.sso.description'), {
          SsoHelpCenterLink
        })}
        </Description>
      </FlexLayout>
      <FlexBox>
        <DestroySettings />
        {isEnforced && <TestSamlConnectionButton />}
      </FlexBox>
      {isLoading ? <Loader /> : <>
            <ContextualBanner spacingBottom="24">
              {HtmlParser(I18n.t('publisher.organization_settings.sso.scim_transition_message'), {
          UserProvisioningLink
        })}
            </ContextualBanner>
            <Step selected={selectedStep === SAML_STEPS.INITIAL} disabled={isEnforced} onSelect={() => dispatch(selectStep(SAML_STEPS.INITIAL))} complete={isConfigured} title={I18n.t('publisher.organization_settings.sso.idp_information.title')}>
              <IdpInformation />
            </Step>
            <Step selected={selectedStep === SAML_STEPS.CONFIGURED} disabled={isEnforced || !isConfigured} complete={isTested} onSelect={() => dispatch(selectStep(SAML_STEPS.CONFIGURED))} title={I18n.t('publisher.organization_settings.sso.connection.title')}>
              <Connection onBackClick={() => dispatch(selectStep(SAML_STEPS.INITIAL))} />
            </Step>
            <Step selected={selectedStep === SAML_STEPS.TESTED || selectedStep === SAML_STEPS.ENFORCED} complete={isEnforced} disabled={!isTested} onSelect={() => dispatch(selectStep(SAML_STEPS.TESTED))} title={I18n.t('publisher.organization_settings.sso.enforcement.title')}>
              <Enforcement />
            </Step>
          </>}
    </>;
};

require("./single_sign_on_setup.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./single_sign_on_setup.js");